import { Controller } from "stimulus";
import createChannel from "cables/cable";

export default class extends Controller {

  connect() {
    this.userAllUnreadMessagesChannel = createChannel({channel: "UserAllUnreadMessagesChannel"}, {
      received: data => {
        if (data.count > 0) {
          this.element.style.display = "";
        } else {
          this.element.style.display = "none";
        }
        this.element.textContent = data.count;
      }
    });
  }

  disconnect() {
    this.userAllUnreadMessagesChannel.unsubscribe()
  }
}
